import KendoListView from '../KendoListView'
import KendoPager from '../KendoPager'

let KendoListViewInstaller = class {
    static install(Vue) {
        Vue.component(KendoListView.name, KendoListView)
        Vue.component(KendoPager.name, KendoPager)
    }
}

export default KendoListViewInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoListViewInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-listview-vue-wrapper/src/kendo-listview-installer/index.js